export default function AssetAppealCoordinatorActions({
  handleAppealApproval,
  setIsRespondBackAssetAppealOpen,
  isApproving,
}: {
  handleAppealApproval?: () => void;
  setIsRespondBackAssetAppealOpen?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  isApproving?: boolean;
}) {
  return (
    <div className="mt-6 flex justify-end gap-3">
      <button
        onClick={handleAppealApproval}
        disabled={isApproving}
        className="px-4 py-2 text-sm font-medium bg-black text-white rounded-md hover:bg-gray-700 disabled:opacity-60"
      >
        {isApproving ? "Approving..." : "Approve"}
      </button>

      <button
        onClick={() => setIsRespondBackAssetAppealOpen?.(true)}
        // disabled={isForwarding}
        className="px-4 py-2 text-sm font-medium bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-60"
      >
        Respond Back
      </button>
    </div>
  );
}
